import { render, staticRenderFns } from "./ContractCompanyView.vue?vue&type=template&id=08534bc8&"
import script from "./ContractCompanyView.vue?vue&type=script&lang=js&"
export * from "./ContractCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports